<script lang="ts">
	import FullscreenVideo from '$lib/fullscreenVideo.svelte';
	import RoundedPlay from '$lib/icons/roundedPlay.svelte';

	let showVideo = $state(false);

	interface Props {
		playbackId: string;
	}

	let { playbackId }: Props = $props();
</script>

<button
	type="button"
	onclick={() => (showVideo = true)}
	class="flex items-center gap-x-3 rounded-full bg-black/[.24] py-2 pl-2 pr-6 text-white backdrop-blur-[14px] transition-colors lg:hover:bg-black/45"
	><span class="rounded-full bg-black/[.22] p-[14px] backdrop-blur-[14px]"
		><RoundedPlay class="h-[16px] w-[15px]" /></span
	>
	<span
		class="text-nowrap text-center text-[16px]/[125%] tracking-[.16px] lg:text-[18px]/[100%] lg:tracking-[.18px]"
		>Play video</span
	></button
>

{#if showVideo}
	<FullscreenVideo
		backgroundWithOpacity
		buttonPos="top-right"
		{playbackId}
		onclose={() => (showVideo = false)}
	/>
{/if}
